import React, { Component } from 'react';
import {Button, Checkbox} from 'react-bootstrap';
import { handleFieldChange } from "../../../../Utils";
import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import Icon from '../../../../components/Icon';

class Form extends Component {
    constructor(props) {
        super(props);

        this.state = {
            affid: '',
            subid: ''
        };


        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();

        this.props.onSubmit(Object.assign({}, this.state));
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit} style={{ height: "auto", maxWidth: "600px" }}>
                    <FieldGroup
                        name="affid"
                        label="Affid:"
                        onChange={this.handleFieldChange}
                        value={this.state.affid}
                        type={'number'}
                        step={'1'}
                        min={'600000'}
                        required
                    />
                    <FieldGroup
                        name="subid"
                        label="subid:"
                        onChange={this.handleFieldChange}
                        value={this.state.subid}
                        required
                    />

                    <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/scenes/PushapiBlock/components/AddForm/index.js